import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../context/UserContext';
import LeftArrow from '../assets/Left_arrow.svg';
import ActionButtons from './ActionButtons';
import useIsMobile from '../hooks/useIsMobile';
import { useConsentActions } from '../hooks/useConsentActions';
import { formatFIType } from '../utils/fiGroups';
import './ConsentDetails.css';
import AuthApis from '../helper/api.service';

const ConsentDetails = (props) => {
    const isMobile = useIsMobile();
	const authApis = new AuthApis();
    const userContext = useContext(UserContext);
    const isFip = userContext.isFip;
    const [state, setState] = useState({
        consentDetails: null,
        arrowHover: false,
        fiuName: '',
    });
    const { revokeConsents, resumeConsents } = useConsentActions(
        authApis,
        props.updateLoader,
        props.history
    );
    useEffect(() => {
        if (props?.location?.state?.data) {
            setState({
                consentDetails: props?.location?.state?.data,
                fiuName: props?.location?.state?.entityName,
                arrowHover: false,
            });
        } else {
            props.history.push('/');
        }
    }, [props?.location?.state]);

    const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();

    const handleBack = () => {
        props.history.push({
            pathname: `/revoke-consent`,
            state: {
                selectedAccounts: props?.location?.state?.selectedAccounts,
                number: props?.location?.state?.number,
                fromConsentDetails: true, // Flag to indicate coming back from consent details
            },
        });
    };

    const dateFormat = (dateString, showTime) => {
        if (dateString) {
            let newDate = new Date(dateString);
            let dataArray = newDate.toString().split(' ');
            if (showTime) {
                return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]} ${dataArray[4]}`;
            }
            return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]}`;
        }
    };

    const handleRevoke = () => {
        revokeConsents(
            [props?.location?.state?.consent],
            props?.location?.state?.number
        );
    };

    const handleResume = () => {
        resumeConsents(
            [props?.location?.state?.consent],
            props?.location?.state?.number
        );
    };

    return (
        <section className="consent-details-page mt-10 mb-10 p-3">
            <div className="row gx-0">
                <div style={{
       				width: isMobile ? '95%' : '40%',
        			margin: '0 auto'
   				}}>
                    <div className="row pt-3 px-3">
                        <div className="col-12 px-3">
                            <div
                                className="d-flex align-items-center mb-2"
                                style={{ minHeight: 32 }}
                            >
                                <span
                                    onClick={handleBack}
                                    onMouseEnter={() =>
                                        setState((prev) => ({ ...prev, arrowHover: true }))
                                    }
                                    onMouseLeave={() =>
                                        setState((prev) => ({ ...prev, arrowHover: false }))
                                    }
                                    style={{
                                        display: 'inline-block',
                                        marginLeft: '-50px',
                                        borderRadius: '50%',
                                        background: state.arrowHover ? '#f0f0f0' : 'transparent',
                                        transition: 'background 0.2s',
                                        padding: '4px',
                                        marginRight: '6px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <img
                                        src={LeftArrow}
                                        alt="left arrow"
                                        style={{
                                            height: 24,
                                            width: 24,
                                            display: 'block',
                                        }}
                                    />
                                </span>
                                <h1
                                    className="fs-14 fw-600 text-start mb-0"
                                    style={{
                                        color: '#4F4F4F',
                                        margin: 0,
                                    }}
                                >
                                    DETAILS OF ACCESS
                                </h1>
                            </div>
                        </div>
                        {isFip && (
                            <div className="row">
                                <div className="col-12">
                                    <h4 className="fs-14 fw-700 text-start" style={{ color: props.customDetails.primaryColor }}>
                                        {state.fiuName}
                                    </h4>
                                </div>
                                <div className="col-6">
                                    <p className="fs-12 fw-500 text-muted text-start">FIU</p>
                                </div>
                            </div>
                        )}
                        <div className="col-12">
                            <p className="fs-14 fw-600 text-black text-start">ACCOUNTS</p>
                        </div>
                        {state.consentDetails?.Accounts?.map((el, i) => {
                            return (
                                <div className="row" key={i}>
                                    <div className="col-12">
                                        <h4 className="fs-14 fw-700 text-start" style={{ color: props.customDetails.primaryColor }}>
                                            {el?.entityName}
                                        </h4>
                                    </div>
                                    <div className="col-6">
                                        <p className="fs-12 fw-500 text-muted text-start">
                                            {el?.accType}
                                        </p>
                                    </div>
                                    <div className="col-6">
                                        <div className="d-flex align-items-center justify-content-end">
                                            <p className="fs-12 fw-500 text-muted mb-0 me-2">
                                                {el?.maskedAccNumber} • <span style={{ color: '#6C6C6C' }}>{formatFIType(el?.FIType || el?.fiType)}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        <div className="col-12 mt-3">
                            <h4 className="fs-14 fw-700 text-start" style={{ color: props.customDetails.primaryColor }}>
                                {capitalize(state?.consentDetails?.fetchType)}
                            </h4>
                        </div>
                        <div className="col-12 mb-3">
                            <p className="fs-12 fw-600 text-muted text-start">
                                {state?.consentDetails?.fetchType === 'ONETIME'
                                    ? 'Information fetch one time'
                                    : `Information fetch ${state?.consentDetails?.Frequency?.value} times a ${state?.consentDetails?.Frequency?.unit}`}
                            </p>
                        </div>
                        <div className="col-6">
                            <h4 className="fs-14 fw-600 text-black text-start">From Date</h4>
                            <p className="fs-12 fw-600 text-muted text-start">
                                {dateFormat(state.consentDetails?.DataDateTimeRange?.from, false)}
                            </p>
                        </div>
                        <div className="col-6">
                            <h4 className="fs-14 fw-600 text-black text-end">To Date</h4>
                            <p className="fs-12 fw-600 text-muted text-end">
                                {dateFormat(state.consentDetails?.DataDateTimeRange?.to, false)}
                            </p>
                        </div>
                        <div className="col-12 mt-3">
                            <h4 className="fs-14 fw-700 text-start" style={{ color: props.customDetails.primaryColor }}>
                                Account Information
                            </h4>
                        </div>
                        <div className="col-12 mb-3">
                            <p className="fs-12 fw-600 text-muted text-start">
                                {state.consentDetails?.consentTypes.map((el, i) => {
                                    return (
                                        <span className="mr-2" key={i}>
                                            {capitalize(el).replace(/[-_]/g, ' ')}
                                            {`${
                                                state.consentDetails?.consentTypes?.length - 1 === i
                                                    ? ''
                                                    : ','
                                            }`}
                                        </span>
                                    );
                                })}
                            </p>
                        </div>
                        <div className="col-6">
                            <h4 className="fs-14 fw-600 text-black text-start">
                                Data {capitalize(state.consentDetails?.mode)}
                            </h4>
                            <p className="fs-12 fw-600 text-muted text-start">
                                Until {state.consentDetails?.DataLife?.value}{' '}
                                {state.consentDetails?.DataLife?.unit}
                            </p>
                        </div>
                        <div className="col-6">
                            <h4 className="fs-14 fw-600 text-black text-end">
                                Consent Expiry
                            </h4>
                            <p className="fs-12 fw-600 text-muted text-end">
                                {dateFormat(state.consentDetails?.expireTime, false)}
                            </p>
                        </div>
                        <div className="col-12 mt-3">
                            <h4 className="fs-14 fw-700 text-start">
                                Account Types
                            </h4>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="d-flex flex-wrap">
                                {state.consentDetails?.fiTypes.map((el, i) => (
                                    <span className="chip" key={i}>
                                        {formatFIType(el)}
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: isMobile ? '95%' : '40%',
       						 	margin: '0 auto',
                            }}
                        >
                            <ActionButtons
                                onRevoke={handleRevoke}
                                onResume={handleResume}
                                selectedAccounts={[props?.location?.state?.consent]}
                                isDisable={false}
                                customDetails={props.customDetails}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConsentDetails;
